import { ModelService } from './ModelService';
import { Account } from '../../model/Account';
import { IAccountService } from '../IAccountService';

export class AccountService extends ModelService<Account> implements IAccountService {
}